// AutoMapper
import { AutoMap } from '@nartc/automapper';

// ViewModel
import { CpcOrganizationunitVm } from "./cpcorganizationunit.vm";

export class ClientPolicyControlExceptionModelVm {
    @AutoMap() cpcId: string;
    @AutoMap() cpcOrganizationunitId: string;
    @AutoMap() cpcCheckMethodId: string;
    @AutoMap() cpcCaseTypeId: string;
    @AutoMap(() => CpcOrganizationunitVm) cpcOrganizationunit: CpcOrganizationunitVm;
}
